<template>
  <div class="item-box-content" style="padding-bottom:0">
    <div class="title-font-style">
      <span>退货信息</span>
    </div>
    <el-form class="details-line-height inner-from">
      <el-row>
        <el-col :span="8">
          <el-form-item label="退货编号：">{{params.retreatNumber}}</el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="售后类型：">{{params.retreatType}}</el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="发起时间：">{{params.createDate}}</el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="退货状态：">
            <span v-show="params.state===1">审核中</span>
            <span v-show="params.state===2">审核不通过</span>
            <span v-show="params.state===3">退货中</span>
            <span v-show="params.state===4">已完成</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="申请人：">{{params.createUser}}</el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="供应商名称：">{{params.suName}}</el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="采购合同编号：">{{params.pcbNumber}}</el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
export default {
  props: ['params'],
  data () {
    return {

    }
  },
  mounted () { },
  methods: {

    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
